// changing "value" will change the route path for that module
export const meshModules = {
  overview: {
    label: 'Overview',
    value: 'overview',
    apiValue: 'OVERVIEW',
  },
  checkIns: {
    label: 'Check-ins',
    value: 'checkIns',
    apiValue: 'CHECK_INS',
  },
  goals: {
    label: 'Goals',
    value: 'goal',
    apiValue: 'GOAL',
  },
  initiatives: {
    label: 'Initiatives',
    value: 'initiative',
    apiValue: 'TASK',
  },
  review: {
    label: 'Reviews',
    value: 'review',
    apiValue: 'REVIEW',
  },
  engagement: {
    label: 'Surveys',
    value: 'engagement',
    apiValue: 'ENGAGEMENT',
  },
  disciplinaryActions: {
    label: 'Disciplinary actions',
    value: 'disciplinaryActions',
    apiValue: 'disciplinaryActions', // to be changed
  },
  oneOnOne: {
    label: '1:1s',
    value: 'oneOnOne',
    apiValue: 'ONE_ON_ONE',
  },
  feedback: {
    label: 'Feedback',
    value: 'feedback',
    apiValue: 'FEEDBACK',
  },
  develop: {
    label: 'Feedback',
    value: 'develop',
    apiValue: 'LEVEL_UP',
  },
  employee: {
    label: 'Employee',
    value: 'employee',
    apiValue: '',
  },
  lifecycle: {
    label: 'Lifecycle',
    value: 'lifecycle',
    apiValue: '',
  },
  compensation: {
    label: 'Compensation',
    value: 'compensation',
    apiValue: 'compensation', // to be confirmed with BE
  },
  points: {
    label: 'Violation Points',
    value: 'points',
    apiValue: 'VIOLATION_POINTS',
  },
} as const;

export const meshModulesPathValues = Object.values(meshModules).map((module) => module.value);

export type MeshModulesPathValue = (typeof meshModulesPathValues)[number];
